angular.module("NumbersEditor").filter('ToPublishDateTime', ['$filter', function ($filter) {
    return function (input) {

        if (input == null)
            return "00:00:00";
        return $filter("date")(input, "HH:mm:ss, dd/MM/yyyy");
    }
}]);